import { REACT_QUERY_OFFLINE_CACHE_PERSISTED_STATE } from 'constants/persistedStates';

export const removeCache = () => localStorage.removeItem(REACT_QUERY_OFFLINE_CACHE_PERSISTED_STATE);
